import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { memo } from 'react';

import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import Anchor from 'components/Anchor';
import UserAvatar from 'components/UserAvatar';

import { getTimeTo } from 'lib/date';
import { sendEvent } from 'lib/gtag';
import { toUserProfileLink } from 'lib/links';

const ListItemUser = ({
  commentDate,
  gaEventCategory,
  userUsername,
  userPhoto,
  userName,
  userTypeName,
}) => {
  const onUserNameClick = () =>
    sendEvent({ category: gaEventCategory, action: 'click_user' });

  return (
    <div className="mt-4 flex items-center">
      <NextLink
        href={toUserProfileLink(userUsername)}
        prefetch={false}
        passHref
      >
        <Anchor className="h-fit">
          <UserAvatar
            loading="lazy"
            size="size5"
            userName={userName}
            userPhoto={userPhoto}
            userTypeName={userTypeName}
          />
        </Anchor>
      </NextLink>
      <div className="ml-2">
        <NextLink
          href={toUserProfileLink(userUsername)}
          prefetch={false}
          passHref
        >
          <Link size="size2" type="secondary" bold onClick={onUserNameClick}>
            {userName}
          </Link>
        </NextLink>
        <Text className="mt-1" size="size2">
          {getTimeTo(commentDate)}
        </Text>
      </div>
    </div>
  );
};

ListItemUser.propTypes = {
  commentDate: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userTypeName: PropTypes.string.isRequired,
  userUsername: PropTypes.string.isRequired,
};

export default memo(ListItemUser);
